import { render } from "./DatasetBuilder.vue?vue&type=template&id=74d742f1"
import script from "./DatasetBuilder.vue?vue&type=script&lang=js"
export * from "./DatasetBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__